import { Pipe, PipeTransform } from '@angular/core';
import { ReviewTargetModel } from '@models/reviewTarget.model';

@Pipe({
  name: 'isFacebook'
})
export class IsFacebookPipe implements PipeTransform{

  transform(reviewTarget: ReviewTargetModel): boolean {
    return !!reviewTarget.name && reviewTarget.name.toLocaleLowerCase().includes('facebook')
  }

}
